import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { BodyStrong } from "theme/components/atoms/Typography/Body";
import NumberInput from "theme/components/atoms/Form/Input/NumberInput";
import Hidden from "theme/components/atoms/Form/Input/Hidden";
import { ProductPrice } from "theme/components/atoms/Typography/Price";

const messages = defineMessages({
  quantityLabel: {
    id: "modules.ProductView.GroupedItems.quantityLabel",
    defaultMessage: "Quantity",
  },
  outOfStock: {
    id: "modules.ProductView.GroupedItems.outOfStock",
    defaultMessage: "Out of stock",
  },
});

const GroupedItemLine = ({ prefix, item, qty }) => {
  const intl = useIntl();

  return (
    <div className="grouped-item-line">
      <div className="grouped-item-line__details">
        <BodyStrong>{item.product.name}</BodyStrong>
        <ProductPrice prices={item.product.prices} forceFinalPrice={true} />
      </div>
      <div className="grouped-item-line__quantity">
        {item.product.stock?.isInStock ? (
          <>
            <Hidden
              name={`${prefix}.sku`}
              id={`${prefix}.sku`}
              value={item.product.sku}
            />
            <NumberInput
              name={`${prefix}.qty`}
              id={`${prefix}.qty`}
              value={qty}
              min={0}
              aria-label={intl.formatMessage(messages.quantityLabel)}
            />
          </>
        ) : (
          <>{intl.formatMessage(messages.outOfStock)}</>
        )}
      </div>
    </div>
  );
};

export default GroupedItemLine;
